import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IDeleteDataRolesParams {
  ids: string[];
}

export interface IDeleteDataRolesResult extends IResult {
}

export class DeleteDataRolesRequest extends Request<IDeleteDataRolesParams, IDeleteDataRolesResult> {
  constructor(ids: string[]) {
    super('deleteDataRoles', { ids: ids });
  }
}
